import Image from 'next/image'
import Link from 'next/link'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_PS_PATH } from 'app/KinerjaShared/constants/path'
import { useApiGetPenilaianPs } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/penilaian'
import CardPeriod from 'app/KinerjaShared/components/CardPeriod'

const CardPredikatByDinas = () => {
  const {
    isLoading,
    isSuccess,
    data: { data: items, meta } = {},
  } = useApiGetPenilaianPs({
    status: ['SUDAH_DIKIRIM'],
    state: 'DINAS_TO_KS',
  })

  const hasData = !isLoading && isSuccess && items?.length > 0

  if (hasData)
    return (
      <Card>
        <div className="flex gap-6 p-6 items-center">
          <div className="flex flex-col">
            <Image
              alt=""
              src="/illustrations/img-document-penci-fill.png"
              width={84}
              height={84}
            />
          </div>
          <div className="flex-1 flex flex-col gap-1 justify-center">
            <div className="flex items-center gap-2">
              <Text variant="heading-lg">
                Penetapan Predikat Kinerja dari Dinas Pendidikan
              </Text>
            </div>
            <Text color="subdued">
              Hasil Penilaian Kinerja Kepala Sekolah bulan{' '}
              <CardPeriod
                enableMultiplePeriodSupport
                withYear={false}
                separator="-"
                year={meta?.skpYear}
                period={meta?.skpPeriod}
              />{' '}
              sudah dikirim dan tidak dapat diubah lagi. Data mungkin muncul
              secara berkala.
            </Text>
          </div>

          <div className="px-6">
            <Link
              href={`${PENGELOLAAN_KINERJA_PS_PATH}/predikat-kinerja`}
              passHref
            >
              <Button as="a" size="lg" color="blue" className="w-60">
                Cek
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    )

  return null
}
export default CardPredikatByDinas
